// Drive.js
import React from 'react';
import { DriveProvider } from './context/DriveContext';
import DriveContent from './DriveContent';

const Drive = () => (
  <DriveProvider>
    <DriveContent />
  </DriveProvider>
);

export default Drive;
